import React, { memo, useCallback } from 'react'
import Channel from './Channel'

import type { ChannelRowProps } from './types'
import { useNavigationMode } from '../../../../shared/providers/NavigationModeProvider/NavigationModeProvider'
import { useHybridFocusable } from '../../hooks/useHybridFocusable'
import HorizontalScroll from '../HorizontalScroll/HorizontalScroll'

const HORIZONTAL_SCROLL_HEIGHT = '200px'

const ChannelRow = ({
  data,
  children,
  onFocus,
  onHover,
  onEnterPress,
  index,
  visibility,
  hasHiddenListingAtStart,
  hasFocusedChild,
  handleHorizontalScrolling,
  canScrollLeft,
  canScrollRight,
}: ChannelRowProps) => {
  const { isCursorMode } = useNavigationMode()
  const { ref, isHovered } = useHybridFocusable({
    focusKey: `channel-${index}`,
  })

  const handleScroll = useCallback(
    (direction) => handleHorizontalScrolling(direction, { index }),
    [handleHorizontalScrolling, index]
  )

  return (
    <div className="epg__channel-row" style={{ visibility }} ref={ref}>
      <Channel
        data={data}
        index={index}
        onFocus={onFocus}
        onHover={onHover}
        onEnterPress={onEnterPress}
        hasFocusedChild={hasFocusedChild}
        hasHiddenListingAtStart={hasHiddenListingAtStart}
      />
      {isCursorMode && isHovered && (
        <HorizontalScroll
          onHorizontalScrolling={handleScroll}
          heightStyle={HORIZONTAL_SCROLL_HEIGHT}
          canScrollLeft={canScrollLeft}
          canScrollRight={canScrollRight}
        />
      )}
      {children}
    </div>
  )
}

export default memo(ChannelRow)
